module.exports = __webpack_public_path__ + "static/media/as.68ae4e24.PNG";